import React from 'react';
import SebiDisclosureFooter from '../components/compliance/SebiDisclosureFooter';

export default function TermsPage() {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <article className="prose prose-sm dark:prose-invert max-w-3xl mx-auto px-6 py-16">
        <h1>KubAIr Terms of Service</h1>
        <p className="text-sm text-muted-foreground">
          Last updated: {new Date().toLocaleDateString('en-IN', { year: 'numeric', month: 'long', day: 'numeric' })}
        </p>

        <h2>1. What KubAIr is</h2>
        <p>
          KubAIr (&quot;KubAIr&quot;, &quot;we&quot;) operates two products on this platform:
        </p>
        <ul>
          <li>
            <strong>KubAIr Research</strong> — equity research, analytics, and AI-assisted analysis for Indian
            public markets, offered to individual investors under KubAIr&apos;s SEBI Research Analyst (RA)
            registration. Content is research and analysis, <strong>not</strong> personalised investment advice.
          </li>
          <li>
            <strong>KubAIr Advisor OS</strong> — a software platform licensed to SEBI-registered intermediaries
            (Investment Advisers, Portfolio Managers, AMCs, Research Analysts, distributors) for use in their
            own regulated business. In this arrangement <strong>you are the adviser / intermediary</strong>; KubAIr
            is a software vendor and is not in the investment chain.
          </li>
        </ul>

        <h2>2. Research is not personalised advice</h2>
        <p>
          Our research, scores, screener output, pitch reports, AI chat responses, and any other analytical
          artefacts on KubAIr Research are issued under our SEBI RA registration. They reflect our analyst
          views on companies and markets in general and are <strong>not</strong> tailored to your financial
          situation, objectives, or risk profile. They do not constitute investment advice under the SEBI
          (Investment Advisers) Regulations, 2013.
        </p>
        <p>
          You are solely responsible for any investment decision you take. You should consider consulting a
          SEBI-registered Investment Adviser before acting on any of KubAIr&apos;s research.
        </p>

        <h2>3. Use of KubAIr Advisor OS (institutional customers)</h2>
        <p>
          If you register as an institutional customer (a &quot;Customer&quot;), you represent and warrant that:
        </p>
        <ol>
          <li>
            You hold a valid, in-force SEBI registration under one or more of the following categories:
            Investment Adviser (IA/RIA), Portfolio Manager (PMS), Research Analyst (RA), Asset Management
            Company (AMC), or you are a registered distributor / AMFI-registered mutual fund distributor.
          </li>
          <li>
            You will display your own SEBI registration and disclosures on every client-facing artefact
            produced using KubAIr Advisor OS. KubAIr&apos;s name appearing as a software credit does not make
            KubAIr the adviser for your clients.
          </li>
          <li>
            You — not KubAIr — are the investment adviser / research analyst / portfolio manager for your
            clients. You are solely responsible for regulatory compliance, fiduciary duty, KYC, risk
            profiling, client suitability, and all regulatory filings for your clients.
          </li>
          <li>
            KubAIr is a software vendor. We process client data you upload strictly on your instructions and
            do not use it to make investment decisions for you or your clients.
          </li>
          <li>
            On request we will execute a Data Processing Agreement (DPA) reflecting this arrangement under
            the Digital Personal Data Protection Act, 2023.
          </li>
        </ol>

        <h2>4. Data &amp; privacy</h2>
        <p>
          Our Privacy Policy (<a href="/privacy">/privacy</a>) describes what personal data we collect, how
          we process it, and your rights under the Digital Personal Data Protection Act, 2023. You can
          export all of your personal data at any time from your account settings, and request deletion.
          Some records (for example, advisor-linked proposals and audit logs) are retained for 5 years as
          required by SEBI regulations; we disassociate these from your identity when you delete your
          account but do not erase them.
        </p>

        <h2>5. No guarantee of returns</h2>
        <p>
          Nothing on KubAIr guarantees any specific return. Investments in securities are subject to market
          risks. Past performance is not indicative of future performance. Data sourced from NSE, BSE,
          MCA, Screener.in, exchange filings, third-party APIs and public disclosures is believed to be
          reliable but is not warranted to be accurate, complete, or current.
        </p>

        <h2>6. Acceptable use</h2>
        <ul>
          <li>No scraping, automated extraction, or resale of KubAIr content without written consent.</li>
          <li>No use of KubAIr to make representations to clients that KubAIr is their adviser.</li>
          <li>No use that violates SEBI, RBI, or other applicable regulations.</li>
        </ul>

        <h2>7. Fees, trials &amp; cancellation</h2>
        <p>
          Subscription plans, trial terms, and cancellation policy are shown at checkout and in your
          billing settings. GST, where applicable, is charged at the statutory rate.
        </p>

        <h2>8. Liability</h2>
        <p>
          To the maximum extent permitted by law, KubAIr&apos;s aggregate liability arising out of or relating
          to this Agreement is limited to the fees you have paid to KubAIr in the 12 months preceding the
          event giving rise to the claim. KubAIr is not liable for indirect, incidental, consequential,
          punitive, or special damages, including lost profits or trading losses, even if advised of the
          possibility.
        </p>

        <h2>9. Governing law &amp; disputes</h2>
        <p>
          These terms are governed by the laws of India. Courts at Bengaluru, Karnataka have exclusive
          jurisdiction, subject to SEBI&apos;s ODR framework where applicable. Grievances relating to SEBI
          RA services may be escalated via <a href="https://scores.sebi.gov.in/" target="_blank" rel="noreferrer">SCORES</a>
          {' '}or the <a href="https://smartodr.in/" target="_blank" rel="noreferrer">SEBI ODR portal</a>.
        </p>

        <h2>10. Contact</h2>
        <p>
          KubAIr, Bengaluru, India.
          General: hello@kubair.in · Compliance: compliance@kubair.in · Grievance: grievance@kubair.in
        </p>
      </article>

      <SebiDisclosureFooter />
    </div>
  );
}
